import React, { PureComponent } from "react";
import { Dimmer, Loader } from "semantic-ui-react";

class SimplePreloader extends PureComponent {
  render() {
    return (
      <Dimmer active className="simple-preloader">
        <Loader size="medium" />
      </Dimmer>
    );
  }
}

export default SimplePreloader;
